export enum MediaListType {
  TEMPLATE_2_COL = '2columns',
  TEMPLATE_3_COL = '3columns',
}
